// eslint-disable-next-line
import I18n from 'lib/I18n';

export const supportUrl = I18n.t("ext_url.post_jira_issue");
